import React from 'react';
import { Avatar } from '@material-ui/core';
import Utils from '../providers/Utils';
import Calendar from 'react-calendar';
import Menu from './Menu';
import Ws from '../providers/Ws';
import ro from 'date-fns/locale/ro';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";
import SpecificComponent from './SpecificComponent';

registerLocale('ro', ro)


export default class TabelTaskIdeea extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }




    ws = new Ws()





    render() {
        return (
            <div>
                <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    tableLayout: 'auto',
                    textAlign: 'left'
                }}>
                    <thead>
                        <tr style={{ borderBottom: '1px solid gray', fontSize: 12, lineHeight: '34px' }}>

                            <th style={{ color: '#b3b3b3' }} >{this.dictionary.proiecte.denumireTask}</th>
                            <th style={{ color: '#b3b3b3' }} >{this.dictionary.proiecte.dateStart}</th>
                            <th style={{ color: '#b3b3b3' }}>{this.dictionary.proiecte.dateFinish}</th>
                            <th style={{ color: '#b3b3b3' }}>{this.dictionary.proiecte.responsable}</th>


                        </tr>
                    </thead>

                    <tbody>
                        {this.props.taskuri.map((t, idx) => {
                            if (!t.edit_task) {
                                return (
                                    <tr onClick={()=>{  this.props.editTask(t, this.props.etapa)}} key={'t' + idx} style={{ borderBottom: '1px solid gray', fontSize: 12, lineHeight: '34px' }}>
                                        <td>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400 }}
                                                id='titlu-task'
                                                type="text"
                                                className='hidden-input'
                                                disabled={true}
                                                margin="normal"
                                                name='titlu'
                                                value={t.titlu || ''}
                                                onChange={(ev) => { this.props.changeTask(ev, t) }}
                                                onBlur={this.props.updateTaskTitle}
                                            />
                                            {/* {t.titlu} */}

                                        </td>
                                        <td style={{ position: 'relative', cursor: 'pointer' }} onClick={() => { this.props.getTaskDates(t, this.props.etapa, true, false) }}>

                                            <span>


                                                {new Utils().ParseDataFromSql(t.cand_data)}

                                                {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                            </span>
                                            {/* 
                                            <DatePicker


                                                style={{ width: '100%', }}
                                                disabled={true}
                                                selected={t.cand_data ? new Date(t.cand_data) : this.props.dtDataStart}
                                                onChange={this.props.dataStartChange}
                                                startDate={this.props.dtDataStart}
                                                shouldCloseOnSelect={true}
                                                calendarClassName="calendar-left-absolute"
                                                locale="ro"
                                                disabled={this.props.readOnly}
                                                dateFormat="dd/MM/yyyy"
                                                customInput={<div    >

                                               

                                                 
                                                </div>}
                                                monthsShown={1}
                                            /> */}



                                            {/* <div style={{
    maxWidth: 220, position: 'absolute',
    top: 30,
    zIndex: 2000
}}>
    <Calendar

        className={t.hide_calendar ? 'pm-hide-calendar' : ''}
        locale={'ro'}
        onChange={this.props.dataStartChange}
        value={this.props.dtDataStart}
    />

</div> */}
                                        </td>
                                        <td style={{ position: 'relative', cursor: 'pointer' }} onClick={() => { this.props.getTaskDates(t, this.props.etapa, false, true) }}>

                                            <span>


                                                {new Utils().ParseDataFromSql(t.pana_cand_data)}

                                                {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                            </span>

                                            {/* <DatePicker
                                                disabled={true}

                                                style={{ width: '100%', }}
                                                selected={t.pana_cand_data ? new Date(t.pana_cand_data) : this.props.dtDataFinish}
                                                onChange={this.props.dataFinishChange}
                                                startDate={this.props.dtDataFinish}
                                                shouldCloseOnSelect={true}
                                                calendarClassName="calendar-left-absolute"
                                                locale="ro"
                                                disabled={this.props.readOnly}
                                                dateFormat="dd/MM/yyyy"
                                                customInput={<div    >

                                                   

                                                </div>}
                                                monthsShown={1}
                                            /> */}





                                            {/*                                         
<div style={{
    maxWidth: 220, position: 'absolute',
    top: 30,
    zIndex: 2000
}}>
    <Calendar

        className={t.hide_calendar_finish ? 'pm-hide-calendar' : ''}
        locale={'ro'}
        onChange={this.props.dataFinishChange}
        value={this.props.dtDataFinish}
    />

</div> */}

                                        </td>
                                        <td style={{ position: 'relative', cursor: 'pointer' }}>
                                            {
                                                t.utilizator_responsabil.length > 0 &&
                                                <div style={{ width: 'fit-content', display: 'inline-block' }}>

                                                    {t.utilizator_responsabil[0].poza ?
                                                        <Avatar
                                                            style={{ display: 'inline-block', width: 30, height: 30, marginTop: 2 }} src={this.ws.adresaMedia + '/Angajati/' + t.utilizator_responsabil[0].poza} />
                                                        :

                                                        <Avatar

                                                            style={{ display: 'inline-block', width: 30, height: 30, textAlign: 'center', marginTop: 2, backgroundColor: new Utils().culoriUtilizatori(t.utilizator_responsabil[0].id) }}>
                                                            <i style={{ verticalAlign: 'middle' }} className='material-icons'>person</i>
                                                        </Avatar>
                                                    }
                                                    <span style={{
                                                        verticalAlign: 'text-bottom', fontWeight: 500,
                                                        marginLeft: 10
                                                    }}> {t.utilizator_responsabil[0].nume}</span>
                                                </div>
                                            }



                                            {t.utilizator_responsabil.length === 0 &&
                                                <div>
                                                    <span style={{ marginRight: 50 }}>{this.dictionary.proiecte.select}</span>
                                                    {/* <span>hello</span> */}
                                                </div>

                                            }



                                            <Menu
                                                openMenu={t.utilizator_view}
                                                e={{ id: 2 }}
                                                elSelectat={{ id: 2 }}
                                                closeMenu={this.props.closeUtilizator}
                                                el={this.props.listUsers}
                                                text={'nume'} />
                                        </td>
                                    </tr>
                                )
                            }
                        })}



                        <tr>
                            <td
                                onClick={() => { this.props.insertTask(this.props.etapa) }}
                                style={{
                                    color: '#b3b3b3',
                                    fontSize: 12,
                                    padding: '10px 0',
                                    cursor: "pointer",
                                    color: 'rgb(113, 227, 255)',
                                    fontWeight: 600
                                }}> {this.dictionary.proiecte.clickNewTask}</td>
                        </tr>

                    </tbody>


                </table>
            </div >
        );
    }
}